/**
 * Stock Table Component
 *
 * Displays marketer stock items using the unified AppTable component
 */

import React, {useState} from 'react';
import {MarketerStockItem} from '../models/report.model';
import AppTable, {TableColumn} from '../../../Presentation/components/ui/AppTable';
import {AppText} from '../../../Presentation/components/ui/Typography';
import DateTimeDisplay from '../../../Presentation/components/ui/DateTimeDisplay';

interface StockTableProps {
  items: MarketerStockItem[];
}

export const StockTable: React.FC<StockTableProps> = ({items}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = items.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => setCurrentPage(page);
  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const columns: TableColumn<MarketerStockItem>[] = [
    {key: 'product_name', title: 'اسم المنتج', render: (row) => <AppText>{row.product_name}</AppText>},
    {key: 'product_sku', title: 'باركود', render: (row) => <AppText>{row.product_sku || '-'}</AppText>},
    {key: 'brand_name', title: 'العلامة التجارية', render: (row) => <AppText>{row.brand_name || '-'}</AppText>},
    {key: 'quantity_available', title: 'المتاح', render: (row) => <AppText>{row.quantity_available}</AppText>}
  ];

  return (
    <AppTable
      columns={columns}
      data={paginatedData}
      rowKey={(row) => row.product_id}
      emptyText="لا توجد بيانات للمخزون"
      hidePagination={false}
      page={currentPage}
      pageSize={pageSize}
      totalCount={items.length}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
    />
  );
};


